// extracted by mini-css-extract-plugin
export default {"customersTable":"hHP9iO9lqH72BG9xC6Vu","extraColumn":"imMas8q_GCouXxBUJVsX"};